import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { FeatureToggleHttpService } from '@services/http/feature-toggles/feature-toggle-http.service';
import { map } from 'rxjs';

/**
 * Libera a rota só para quem tem a feature flag (card 3295). Sem a flag, devolve o `UrlTree` de
 * `redirectTo` em vez de navegar por efeito colateral: a tela que não é o destino nem chega a montar.
 *
 * Uso: `canActivate: [featureFlagGuard('dashboard-economy-history', '/dashboard/dashboard-management')]`.
 */
export function featureFlagGuard(key: string, redirectTo: string): CanActivateFn {
  return () => {
    const router = inject(Router);
    return inject(FeatureToggleHttpService)
      .isEnabled(key)
      .pipe(map(enabled => (enabled ? true : router.parseUrl(redirectTo))));
  };
}

/**
 * Escolhe entre duas rotas com o mesmo `path` pela feature flag: com a flag, casa esta; sem ela, o roteador segue
 * para a próxima rota de mesmo `path` (a versão anterior da tela). A URL não muda.
 *
 * Uso: a rota nova com `canMatch: [featureFlagMatch('dashboard-home')]`, logo acima da rota antiga sem guard.
 */
export function featureFlagMatch(key: string): CanMatchFn {
  return () => inject(FeatureToggleHttpService).isEnabled(key);
}
